// Adds a class to emulate placeholder text styles
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#gform_1.form_contact-us');
  if (!form) return;

  form.querySelectorAll('select').forEach(select => {
    const updatePlaceholderState = () => {
      const isPlaceholder = select.value === '';
      select.classList.toggle('placeholder-active', isPlaceholder);
    };

    select.addEventListener('change', updatePlaceholderState);
    updatePlaceholderState();
  });
});